import { REQUEST } from 'crom-api-constants'

export const GET_MINIREPORT = 'GET_MINIREPORT'
export const GET_MINIREPORT_REQUEST = `GET_MINIREPORT_${REQUEST}`

export const LOCALE_PREFIX = 'components.Minireport'

export const MODULE_QUERIES = {
    report: 'REPO',
    portfolio: 'FMWK',
}
